import { IMessage } from "models/Message"
import { Trans } from "react-i18next"
import toastMessages from "stores/toastMessages"

export default function useCopyToClipboard() {
    async function copyToClipboard({ text, toast }: {
        text: string
        toast?: IMessage
    }) {
        try {
            // @note: copying will only work on https and localhost urls
            // because of browser security restrictions
            await navigator.clipboard.writeText(text)
            toastMessages.show(toast || {
                descr: <Trans i18nKey="message.copiedToClipboard" values={{ copyText: text }}>
                    <span className="font-bold">{text}</span> copied to clipboard
                </Trans>,
            })
        } catch (e) {
            toastMessages.showSystemError()
        }
    }

    return copyToClipboard
}
